import React, { createContext, useState } from "react";

export const ProductosContext = createContext();

export const ProductosContextProvider = ({ children }) => {
    
  


  const [orden, setOrden] = useState('')
  return (
    <ProductosContext.Provider
      value={{
        orden,
        setOrden,
      }}
    >
      {children}
    </ProductosContext.Provider>
  );
};
